const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3000/api";

const API_ENDPOINTS = {
  HOME_MOVIES: `${BASE_URL}/home/movies`,
  HOME_TV_SHOWS: `${BASE_URL}/home/tv-shows`,
  TRENDING_MOVIES: `${BASE_URL}/trending/movies`,
  TRENDING_TV_SHOWS: `${BASE_URL}/trending/tv-shows`,
  MOVIE_DETAIL: (slug) => `${BASE_URL}/movies/${slug}`,
  TV_SHOW_DETAIL: (slug) => `${BASE_URL}/tv-shows/${slug}`,
  MOVIE_GENRES: `${BASE_URL}/movie-genres`,
  TV_SHOW_GENRES: `${BASE_URL}/tv-show-genres`,
  MOVIE_TAGS: `${BASE_URL}/movie-tags`,
  TV_SHOW_TAGS: `${BASE_URL}/tv-show-tags`,
  MOVIE_YEARS: `${BASE_URL}/movie-years`,
  TV_SHOW_YEARS: `${BASE_URL}/tv-show-years`,
  LIST_MOVIES: `${BASE_URL}/list/movies/all`,
  LIST_TV_SHOWS: `${BASE_URL}/list/tv-shows/all`,
  SEARCH: `${BASE_URL}/search`,
  FILTER: `${BASE_URL}/filter`,
  FEEDBACK: `${BASE_URL}/feedback`,
  DMCA: `${BASE_URL}/dmca`,

};

export default API_ENDPOINTS;
